import { createFileRoute, redirect } from '@tanstack/react-router'
import { myChannelsQuery } from '../../lib/channels'

// Home: go to #general (or the first channel) when there is one.
export const Route = createFileRoute('/_app/')({
  beforeLoad: async ({ context }) => {
    const channels = await context.queryClient.ensureQueryData(myChannelsQuery)
    const general = channels.find((c) => c.slug === 'general') ?? channels[0]
    if (general?.slug) throw redirect({ to: '/c/$slug', params: { slug: general.slug } })
  },
  component: () => (
    <div className="flex h-full items-center justify-center text-fg-muted">
      <p>Pick a channel.</p>
    </div>
  ),
})
